import React from "react";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";

type props = {
  title: string;
  isSelected: boolean;
  onPress: () => void;
};

export const CourtZone: React.FC<props> = ({ title, isSelected, onPress }) => {
  return (
    <div
      onClick={onPress}
      style={{
        minWidth: 107,
        height: 36,
        borderRadius: 12,
        backgroundColor: isSelected ? Colors.green : Colors.lightGreyBackground,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <TCText
        style={{
          fontWeight: 500,
          fontSize: 12,
          color: isSelected ? "white" : "black",
        }}
        value={title}
      />
    </div>
  );
};
